import {isSome} from "fp-ts/Option";
import {useAppSelector} from "../../app/hooks";

export function useIsLoggedIn() {
    return useAppSelector(x => isSome(x.loginSlice.activeUserDetails))
}